<div class="row justify-content-center" *ngIf="course==null">
  <div class="spinner-border m-2 text-danger" role="status">
    <span class="sr-only">Loading...</span>
  </div>
</div>

<div class="card card-box mb-5" *ngIf="course!=null">
  <div class="card-header py-3">
    <div class="card-header--title font-size-lg">
      <b><i class="fas fa-book"></i> Coourses </b>
    </div>

    <div class="card-header--actions">
      <button class="btn btn-sm btn-neutral-secondary" type="button" (click)="viewMore()">
                      <span class="btn-wrapper--icon">
                          <fa-icon [icon]="['fas', 'plus-circle']" class="text-success"></fa-icon>
                      </span>
        <span class="btn-wrapper--label">
                          New Course
                      </span>
      </button>
    </div>

  </div>
  <div class="d-flex justify-content-between px-4 py-3">
    <form [formGroup]="searchform">
      <div class="search-wrapper btn-group">
          <span class="icon-wrapper text-black">
            <fa-icon [icon]="['fas', 'search']"></fa-icon>
          </span>
        <input class="form-control-sm form-control" formControlName="search" placeholder="Search terms..." type="search">
        <button CLASS="btn btn-neutral-success btn-sm" (click)="search(1)">Search</button>
      </div>
    </form>
  </div>
  <div class="divider"></div>
  <div class="table-responsive">
    <table class="table table-hover text-nowrap mb-0">
      <thead>
      <tr>
        <th class="bg-white text-center">NAME</th>
        <th class="bg-white text-center">DESCRIPTION</th>
        <th class="bg-white text-center">VIEW</th>
        <th class="bg-white text-center">ACTIONS</th>
        <!--        <th class="bg-white text-center">Actions</th>-->
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let pac of course">
        <td class="font-weight-bold text-center">
          {{pac.name}}
        </td>
        <td class="text-center">
          <span style="font-size: 15px" class="badge bg-neutral-danger text-danger">
            {{(pac.description| slice:0:30) + '...'}}
          </span>
        </td>
        <td class="text-center">
          <button type="button" class="btn btn-success btn-sm" (click)="viewDesc(pac)">
            <i class="fas fa-eye"></i>
          </button>
        </td>
        <td class="font-weight-bold text-center">
          <div class="btn-group btn-group-sm m-2" role="group" aria-label="Basic example">
            <button type="button" class="btn btn-warning" (click)="update(pac)">
              <i class="fas fa-upload"></i>
            </button>
            <button type="button" class="btn btn-danger" (click)="dlete(pac.id)">
              <i class="fas fa-trash-alt"></i>
            </button>
          </div>
        </td>

        <!--        <td class="text-center">-->
        <!--          <div class="btn-group btn-group-sm m-2" role="group" aria-label="Basic example">-->
        <!--&lt;!&ndash;            <button type="button" class="btn btn-success" (click)="approve(pac.id)" ><i class="fas fa-check-circle"></i></button>&ndash;&gt;-->
        <!--            <button type="button" class="btn btn-danger" (click)="reject(pac.id)"><i-->
        <!--              class="far fa-trash-alt"></i></button>-->

        <!--          </div>-->
        <!--        </td>-->
      </tr>

      </tbody>
    </table>
  </div>
  <div class="card-footer py-3 d-flex justify-content-between">

  </div>
</div>

<div bsModal #addModal="bs-modal" class="modal fade" tabindex="-1"
     role="dialog" aria-labelledby="dialog-sizes-name1">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h6 class="modal-title">{{ty}} Course</h6>
        <button type="button" class="close" (click)="addModal.hide()" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="card-body">
          <form [formGroup]="newsForm">
            <div class="m-2">
              <select class="form-control" placeholder="Title" type="text" formControlName="dest">
                <option *ngFor="let d of dest" value="{{d.id}}">{{d.name}}</option>
              </select>
            </div>
            <div class="m-2">
              <input class="form-control" placeholder="Course name" type="text" formControlName="title">
            </div>
            <div class="m-2">
              <textarea class="form-control" placeholder="Description" formControlName="desc" cols="30"
                        rows="10"></textarea>
            </div>

          </form>
          <div class="m-2">
            <!--            <button class="btn btn-success">Submit</button>-->
          </div>

        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-link btn-link-dark" (click)="addModal.hide()">Close</button>
        <button *ngIf="up!=true" type="button" class="btn btn-success ml-auto" [disabled]="!newsForm.valid"
                (click)="createCourse()">Save changes
        </button>
        <button *ngIf="up==true" type="button" class="btn btn-warning ml-auto" [disabled]="!newsForm.valid"
                (click)="upAction()">Update
        </button>
      </div>
    </div>
  </div>
</div>

<div bsModal #view="bs-modal" class="modal fade" tabindex="-1"
     role="dialog" aria-labelledby="dialog-sizes-name1">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h6 class="modal-title">Course</h6>
        <button type="button" class="close" (click)="view.hide()" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="card-body">
          <h4 class="text-primary">{{noteTitle}}</h4>

          <p>{{note}}</p>

        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-link btn-link-dark" (click)="view.hide()">Close</button>
      </div>
    </div>
  </div>
</div>
<notifier-container></notifier-container>
